import * as Yup from "yup";
import { flowVersion } from "./flowVersion";

const {
  formField: { createNewVersion }
} = flowVersion;

export const validations = Yup.object().shape({
  [createNewVersion.name]: Yup.string().required(createNewVersion.errorMsg)
});
